import { useCallback, useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { api, apiError } from "@/lib/api";
import { AdminButton, AdminCard } from "@/components/admin/ui";

export const MenuQrCard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [copiato, setCopiato] = useState(false);
  const canvas = useRef(null);

  const carica = useCallback(async (rigenera = false) => {
    try {
      const { data: res } = await api.get("/admin/menu-qr", { params: rigenera ? { rigenera: true } : {} });
      // L'indirizzo si compone sul dominio da cui stai usando il pannello.
      setData({ ...res, url: `${window.location.origin}/carta/${res.token}` });
    } catch (err) {
      setError(apiError(err));
    }
  }, []);

  useEffect(() => {
    carica();
  }, [carica]);

  useEffect(() => {
    if (data?.url && canvas.current) {
      QRCode.toCanvas(canvas.current, data.url, {
        width: 640,
        margin: 2,
        color: { dark: "#2A2A28", light: "#F7F3EA" },
        errorCorrectionLevel: "M",
      });
    }
  }, [data]);

  const scarica = () => {
    const link = document.createElement("a");
    link.download = "qr-carta-osteria-aterrana.png";
    link.href = canvas.current.toDataURL("image/png");
    link.click();
  };

  const copia = async () => {
    await navigator.clipboard?.writeText(data.url);
    setCopiato(true);
    window.setTimeout(() => setCopiato(false), 3000);
  };

  const rigenera = () => {
    if (
      window.confirm(
        "Rigenerando l'indirizzo i QR già stampati smettono di funzionare. Procedo?",
      )
    ) {
      carica(true);
    }
  };

  return (
    <AdminCard title="QR della carta al tavolo" testId="menu-qr-card">
      <p className="mb-5 text-sm text-foreground/65">
        Questa carta mostra <strong>i prezzi</strong> ed è raggiungibile solo da chi ha il QR:
        non è collegata al sito, non compare su Google ed è esclusa dai motori di ricerca.
        Il menù pubblico resta senza prezzi.
      </p>
      {error && <p className="mb-4 text-sm text-destructive">{error}</p>}
      {data && (
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
          <canvas
            ref={canvas}
            className="h-44 w-44 shrink-0 border border-wood/15 bg-cream"
            data-testid="menu-qr-canvas"
          />
          <div className="min-w-0 flex-1">
            <p className="text-[0.65rem] uppercase tracking-[0.14em] text-wood/50">Indirizzo segreto</p>
            <p className="mt-1 break-all text-sm text-wood" data-testid="menu-qr-url">
              {data.url}
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <AdminButton variant="wood" onClick={scarica} data-testid="menu-qr-download">
                Scarica il QR
              </AdminButton>
              <AdminButton variant="outline" onClick={copia} data-testid="menu-qr-copy">
                {copiato ? "Copiato" : "Copia indirizzo"}
              </AdminButton>
              <AdminButton variant="outline" onClick={rigenera} data-testid="menu-qr-regen">
                Rigenera indirizzo
              </AdminButton>
            </div>
            <p className="mt-4 text-xs leading-relaxed text-foreground/55">
              Scarica il PNG e portalo in tipografia: la dimensione consigliata per un tavolo è
              almeno 3 cm di lato. Se un QR finisse in mani sbagliate, rigenera l'indirizzo: quelli
              stampati smetteranno di funzionare.
            </p>
          </div>
        </div>
      )}
    </AdminCard>
  );
};

export default MenuQrCard;
